var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('TermTabs',{model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_c('v-list',_vm._l((_vm.courses),function(course){return _c('Course',{key:course.id,attrs:{"value":course,"clickable":"","nodetails":"","to":{ name: 'Course', params: { id: course.id } }}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }